import { DateTime } from 'luxon';
import { SectionVM } from 'civil-status/view-models/step-form';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { SubjectData } from 'shell/models/person';

export const transformerActBorn = (person: SubjectData): SectionVM | undefined => {
  const { attoNascitaANPR } = person;

  const paperAct = attoNascitaANPR?.atto;
  const digitalAct = attoNascitaANPR?.attoANSC;

  const dataFormazioneAtto = paperAct?.dataFormazioneAtto || digitalAct?.dataFormazioneAtto;
  const trascritto = paperAct?.trascritto || digitalAct?.trascritto;
  const comuneRegistrazione = paperAct?.comuneRegistrazione || digitalAct?.comuneRegistrazione;
  const anno = paperAct?.anno || digitalAct?.anno;
  const numero = paperAct?.numeroAtto || digitalAct?.numeroComunale;

  return {
    typeAct: Boolean(paperAct)
      ? CodeTypeAct.attoCartaceo
      : Boolean(digitalAct)
      ? CodeTypeAct.attoDigitale
      : CodeTypeAct.nessunAtto,
    actForm: {
      idAnsc: digitalAct?.idANSC,
      dateAct: dataFormazioneAtto ? DateTime.fromISO(dataFormazioneAtto) : null,
      typeEvent: trascritto === '0' ? '1' : trascritto === '1' ? '3' : '1',
      register: ID_REGISTER.NASCITA,
      year: anno,
      portion: paperAct?.parte,
      serie: paperAct?.serie,
      volume: paperAct?.volume,
      municipalNumber: numero,
      italian: comuneRegistrazione
        ? {
            municipality: {
              description: comuneRegistrazione.nomeComune || '',
              id: person.idComuneRegistrazione || undefined,
              code: person.idComuneRegistrazione || undefined,
              istatCode: comuneRegistrazione.codiceIstat || '',
              province: comuneRegistrazione.siglaProvinciaIstat || '',
              idProvince: person.idProvRegistrazione || undefined,
            },
          }
        : undefined,
    },
  } as SectionVM;
};
